import i18 from "i18next";

export const makeRef = (href: string, lang: string): string => {
  const onLang = href.includes(`/${i18.language}`);
  return onLang
    ? href.replace(`/${i18.language}`, `/${lang}`)
    : `${href}${lang}`;
};
